import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { StoresRepository } from '~repositories/StoresRepository';
import { IGeoLocation } from '~domain/entities/UserLocation';
import { FindInStore } from '~domain/entities/FindInStore';
import { SearchedLocationRepository } from '~repositories/SearchedLocationRepository';
import { FiltersRepository } from '~repositories/FiltersRepository';
import { BopisFiltersRepository } from '~repositories/BopisRepositories/BopisFiltersRepository';

export interface IFetchDataStrategy {
    loadStores(searchLocation: IGeoLocation): void;
}

export class StoreLocatorFetchDataStrategy implements IFetchDataStrategy {
    private storesRepository: StoresRepository;
    private searchedLocationRepository: SearchedLocationRepository;
    private filtersRepository: FiltersRepository;

    constructor() {
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.searchedLocationRepository = diContainer.get(serviceNames.searchedLocationRepository);
        this.filtersRepository = diContainer.get(serviceNames.filtersRepository);
    }

    public loadStores = async (searchLocation: IGeoLocation) => {
        const activeFilters = this.filtersRepository.activeFilters;
        const servicesAvailableFilter = this.filtersRepository.servicesAvailableFilter;
        const inStorePickupFilter = this.filtersRepository.inStorePickupFilter;
        this.searchedLocationRepository.updateGeolocation(searchLocation);
        await this.storesRepository.loadStoresByLocation(
            searchLocation,
            activeFilters,
            servicesAvailableFilter,
            inStorePickupFilter
        );
    };
}

export class FindInStoreFetchDataStrategy implements IFetchDataStrategy {
    private storesRepository: StoresRepository;
    private findInStore: FindInStore;

    constructor() {
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.findInStore = diContainer.get(serviceNames.findInStore);
    }

    public loadStores = async (searchLocation: IGeoLocation) => {
        await this.storesRepository.loadStoreInventory(this.findInStore.skuId, searchLocation);
    };
}

export class BuyOnlinePickupInStoreFetchDataStrategy implements IFetchDataStrategy {
    private storesRepository: StoresRepository;
    private findInStore: FindInStore;
    private filtersRepository: BopisFiltersRepository;

    constructor() {
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.findInStore = diContainer.get(serviceNames.findInStore);
        this.filtersRepository = diContainer.get(serviceNames.bopisFiltersRepository);
    }

    public loadStores = async (searchLocation: IGeoLocation) => {
        const activeFilters = this.filtersRepository.activeFilters;
        await this.storesRepository.loadBOPISInventoryByCoords(
            this.findInStore.skuBaseId,
            searchLocation,
            activeFilters
        );
    };
}
